import {
  Box,
  Button,
  IconButton,
  Menu,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import TextView from "../../Components/UI/TextView/TextView";
import { getAppointmentCountDetail } from "../../connections/getApi";
import { useNavigate } from "react-router-dom";
import UseFetchAppointmentCount from "../../helper/UseFetchAppointmentCount";
import UseFetchUpcomingholidays from "../../helper/UseFetchUpcomingholidays";
import { logout } from "../../redux/slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CustomModal from "../../Components/CustomModal/CustomModal";
import AddIcon from "@mui/icons-material/Add";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import supplier from "../../assets/supplier.svg";
import medicine_salt from "../../assets/medicine_salt.svg";
import medicine from "../../assets/medicine.svg";
import rupee from "../../assets/rupee.svg";
import UseFetchCollections from "../../helper/UseFetchCollections";
import TotalCollection from "../../Components/ModalChildren/TotalCollection";
import NewBillPharmacy from "../../Components/ModalChildren/NewBillPharmacy";
import PurchaseOrder from "../../Components/ModalChildren/PurchaseOrder";
import Supplier from "../../Components/ModalChildren/Supplier";
import Medicines from "../../Components/ModalChildren/Medicines";
import MedicinesEnquiry from "../../Components/ModalChildren/MedicinesEnquiry";
import MedicineSalt from "../../Components/ModalChildren/MedicineSalt";
import MedicalTests from "../../Components/ModalChildren/MedicalTests";
import PharmacyAdmin from "../../Components/ModalChildren/PharmacyAdmin";
import { Menu as MenuIcon } from "@mui/icons-material";
import logo from "../../assets/logo_sq.svg";
import LedgerEntries from "../../Components/ModalChildren/LedgerEntries";
import useOrgName from "../../helper/useOrgName";

const PharmacyNavbar = () => {
  const isMdUp = useMediaQuery("(min-width:750px)");
  const [appointmentType, setAppointmentType] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const toggleMobileMenu = () => setMobileOpen(!mobileOpen);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [appointments, setAppointments] = useState([]);
  const [openNewBill, setOpenNewBill] = useState(false);
  const [openSuppliers, setOpenSuppliers] = useState(false);
  const [openPurchaseOrder, setOpenPurchaseOrder] = useState(false);
  const [openMedicines, setOpenMedicines] = useState(false);
  const [openMedicinesSalt, setOpenMedicinesSalt] = useState(false);
  const [openMedicinesSaltEnquiry, setOpenMedicinesSaltEnquiry] =
    useState(false);
  const [openPharmacy, setOpenPharmacy] = useState(false);
  const [MedicalTest, setMedicalTest] = useState(false);
  const [openCollection, setOpenCollection] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const appointmentPage = 1;
  const appointmentPerPage = 10;

  const authState = useSelector((state) => state.auth);
  const orgName = useOrgName();

  const handleGetAppointmentDetail = async (value) => {
    const res = await getAppointmentCountDetail(
      appointmentPage,
      appointmentPerPage,
      value,
    );
    if (res.status?.status === "SUCCESS") {
      setAppointmentType(value);
      setAppointments(res?.payload?.appointments);
      setAppointmentType(value);
    }
  };

  const handleOpenNewBillOpen = () => setOpenNewBill(true);
  const handleOpenNewBillCLose = () => setOpenNewBill(false);

  const handleOpenPurchaseOrderClose = () => setOpenPurchaseOrder(false);
  const handleOpenPurchaseOrderOpen = () => setOpenPurchaseOrder(true);

  //  {handle total collections  Status modal}
  const handleTotalCollectionOpen = () => setOpenCollection(true);
  const handleTotalCollectionCLose = () => setOpenCollection(false);

  const { data: collectionArray, refetch: refetchMedicine } =
    UseFetchCollections(selectedDate);

  const { data: countData } = UseFetchAppointmentCount();
  const { data: holidays } = UseFetchUpcomingholidays();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          p: 0,
          m: 0,
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          {/* /* MOBILE BURGER */}
          {/* {!isMdUp &&
                        (<IconButton onClick={toggleMobileMenu}>
                            <MenuIcon sx={{ color: 'black', height: '1.5rem', width: '1.5rem' }} />
                        </IconButton>)} */}

          {/* LEFT - LOGO */}
          <Box display="flex" alignItems="center">
            <img src={logo} alt="logo" style={{ width: "3.5rem" }} />
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            color: "black",
            justifyContent: "space-between",
            width: "100%",
            marginLeft: "1rem",
            overflowX: "auto",
            scrollbarWidth: "none", // Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Chrome, Safari, Edge
            },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: "#FFFFFF",
                border: "2px solid #E1E1E1",
                borderRadius: "16PX",
                paddingX: "15px",
                paddingRight: "6px",
                paddingY: "15PX",
                marginLeft: "8px",
                height: "fit-content",
              }}
              onClick={handleOpenNewBillOpen}
            >
              <Box
                sx={{
                  backgroundColor: "#FFE7DC",
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <AddIcon
                  sx={{
                    height: "24px",
                    color: "#FF8D1E",
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <TextView
                  fontSize={"14px"}
                  sx={{
                    mx: 1,
                    color: "#3A3A3A",
                    marginBottom: "3px",
                    fontWeight: "600",
                  }}
                >
                  New Bill
                </TextView>
                <TextView
                  fontSize={"14px"}
                  sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                >
                  {/* New Bill */}
                </TextView>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: "#FFFFFF",
                border: "2px solid #E1E1E1",
                borderRadius: "16PX",
                paddingX: "15px",
                paddingRight: "6px",
                paddingY: "15PX",
                marginLeft: "8px",
                height: "fit-content",
              }}
              onClick={handleOpenPurchaseOrderOpen}
            >
              <Box
                sx={{
                  backgroundColor: "#0067FF40",
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CreditCardIcon
                  sx={{ color: "neutral.navyBlue", height: "30px" }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <TextView
                  fontSize={"14px"}
                  sx={{
                    mx: 1,
                    color: "#3A3A3A",
                    marginBottom: "3px",
                    fontWeight: "600",
                  }}
                >
                  Purchase Order
                </TextView>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: "#FFFFFF",
                border: "2px solid #E1E1E1",
                borderRadius: "16PX",
                paddingX: "15px",
                paddingRight: "6px",
                paddingY: "15PX",
                marginLeft: "8px",
                height: "fit-content",
              }}
              onClick={() => {
                setOpenSuppliers(true);
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#0067FF40",
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={supplier}
                  alt=""
                  sx={{
                    height: "24px",
                    color: "#FF8D1E",
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <TextView
                  fontSize={"14px"}
                  sx={{
                    mx: 1,
                    color: "#3A3A3A",
                    marginBottom: "3px",
                    fontWeight: "600",
                  }}
                >
                  Suppliers
                </TextView>
                <TextView
                  fontSize={"14px"}
                  sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                ></TextView>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: "#FFFFFF",
                border: "2px solid #E1E1E1",
                borderRadius: "16PX",
                paddingX: "15px",
                paddingRight: "6px",
                paddingY: "15PX",
                marginLeft: "8px",
                height: "fit-content",
              }}
              onClick={() => {
                setOpenMedicines(true);
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#0067FF40",
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={medicine}
                  alt=""
                  sx={{
                    height: "24px",
                    color: "#FF8D1E",
                    // "&:hover": {
                    //   color: "black",
                    // },
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <TextView
                  fontSize={"14px"}
                  sx={{
                    mx: 1,
                    color: "#3A3A3A",
                    marginBottom: "3px",
                    fontWeight: "600",
                  }}
                >
                  Medicines
                </TextView>
                <TextView
                  fontSize={"14px"}
                  sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                ></TextView>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: "#FFFFFF",
                border: "2px solid #E1E1E1",
                borderRadius: "16PX",
                paddingX: "15px",
                paddingRight: "6px",
                paddingY: "15PX",
                marginLeft: "8px",
                height: "fit-content",
              }}
              onClick={() => {
                setOpenMedicinesSaltEnquiry(true);
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#0067FF40",
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={medicine}
                  alt=""
                  sx={{
                    height: "24px",
                    color: "#FF8D1E",
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <TextView
                  fontSize={"14px"}
                  sx={{
                    mx: 1,
                    color: "#3A3A3A",
                    marginBottom: "3px",
                    fontWeight: "600",
                  }}
                >
                  Medicines Enquiry
                </TextView>
                <TextView
                  fontSize={"14px"}
                  sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                ></TextView>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: "#FFFFFF",
                border: "2px solid #E1E1E1",
                borderRadius: "16PX",
                paddingX: "15px",
                paddingRight: "6px",
                paddingY: "15PX",
                marginLeft: "8px",
                height: "fit-content",
              }}
              onClick={() => {
                setOpenMedicinesSalt(true);
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#0067FF40",
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={medicine_salt}
                  alt=""
                  sx={{
                    height: "24px",
                    color: "#FF8D1E",
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <TextView
                  fontSize={"14px"}
                  sx={{
                    mx: 1,
                    color: "#3A3A3A",
                    marginBottom: "3px",
                    fontWeight: "600",
                  }}
                >
                  Medicine Salt
                </TextView>
                <TextView
                  fontSize={"14px"}
                  sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                ></TextView>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: "#FFFFFF",
                border: "2px solid #E1E1E1",
                borderRadius: "16PX",
                paddingX: "15px",
                paddingRight: "6px",
                paddingY: "15PX",
                marginLeft: "8px",
                height: "fit-content",
              }}
              onClick={() => {
                refetchMedicine();
                handleTotalCollectionOpen();
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#EAF2F4",
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={rupee}
                  width={"28px"}
                  sx={{ color: "#21C0A6" }}
                  alt="rupee"
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <TextView
                  fontSize={"14px"}
                  sx={{
                    mx: 1,
                    color: "#3A3A3A",
                    marginBottom: "3px",
                    fontWeight: "600",
                  }}
                >
                  Collections
                </TextView>

                {/* <TextView
                        fontSize={"20px"}
                        fontWeight={"600"}
                        variant={"h6"}
                        sx={{ mx: 2 }}
                      >
                        {countData?.collections || 0}
                      </TextView> */}
              </Box>
            </Box>
          </Box>

          {/*         
              {holidays?.holidays?.length > 0 && (
    holidays.holidays.slice(0, 2).map((holiday, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          cursor: "pointer",
          padding: "10px 10px",
          borderRadius: "15px",
          backgroundColor: "#FFE7DC",
        }}
      >
        <TextView
          fontSize="0.70rem"
          sx={{ mx: 2, color: "#3A3A3A" }}
        >
          Holiday
        </TextView>
        <TextView fontWeight={400} fontSize="0.87rem" sx={{ mx: 2 }}>
          {holiday.date} - {holiday.end_date}
        </TextView>
        <TextView
          fontSize="0.87rem"
          sx={{ mx: 2, color: "#f58633" }}
        >
          {holiday.details}
        </TextView>
      </Box>
    ))
  )}
  
               */}
        </Box>

        <Box alignSelf={"right"}>
          <IconButton onClick={handleMenuOpen} color="black">
            <AccountCircleIcon
              sx={{ height: "3rem", width: "3rem", color: "black" }}
            />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              marginLeft: "2.5rem",
              marginTop: "-0.5rem",
              "& .MuiPaper-root": {
                borderRadius: "12px",
                // padding: "16px",
                minWidth: "180px",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "3px",
                p: 2,
              }}
            >
              {orgName && (
                <Box
                  sx={{
                    fontFamily: "Lato",
                    fontWeight: 700,
                    fontSize: "0.95rem",
                    marginBottom: "2px",
                    color: "neutral.navyBlue",
                  }}
                >
                  {orgName}
                </Box>
              )}
              <Box sx={{ fontFamily: "Outfit" }}> {authState?.first_name} </Box>

              <Box
                sx={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                  fontFamily: "sans-serif",
                }}
              >
                {authState?.user}
              </Box>

              <Box sx={{ marginTop: "5px", fontSize: "0.87rem" }}>
                {authState?.email}
              </Box>

              <Button
                //  style={{border :'2px solid black'}}
                disableRipple
                startIcon={
                  <LogoutOutlinedIcon
                    sx={{
                      borderRadius: "50%",
                      padding: "8px",
                      color: "neutral.navyBlue",
                      "&:hover": {
                        // backgroundColor: "neutral.navyBlue",
                        color: "white",
                      },
                    }}
                  />
                }
                sx={{
                  backgroundColor: "neutral.blueShadeBg",
                  marginTop: "0.5rem",
                  color: "grey",
                  "&:hover": {
                    backgroundColor: "neutral.blueShadeBg",
                    color: "gray",
                    "& .MuiSvgIcon-root": {
                      backgroundColor: "neutral.teal",
                      color: "white",
                    },
                  },
                  borderRadius: "14px",
                  textTransform: "capitalize",
                  width: "100%",
                  justifyContent: "flex-start",
                  fontSize: "16px",
                }}
                onClick={handleLogout}
              >
                Logout
              </Button>
            </Box>
          </Menu>
        </Box>
      </Toolbar>
      <CustomModal
        customStyles={{ border: "none", width: "90%" }}
        open={openCollection}
        onClose={() => handleTotalCollectionCLose(null)}
      >
        <TotalCollection onClose={() => handleTotalCollectionCLose(null)} />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "90%" }}
        open={openNewBill}
        onClose={() => handleOpenNewBillCLose(null)}
      >
        <NewBillPharmacy onClose={() => handleOpenNewBillCLose(null)} />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "90%" }}
        open={openPurchaseOrder}
        onClose={() => handleOpenPurchaseOrderClose(null)}
      >
        <PurchaseOrder onClose={() => handleOpenPurchaseOrderClose(null)} />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "90%" }}
        open={openSuppliers}
        onClose={() => setOpenSuppliers(false)}
      >
        <Supplier onClose={() => setOpenSuppliers(false)} />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "90%" }}
        open={openMedicines}
        onClose={() => setOpenMedicines(false)}
      >
        <Medicines onClose={() => setOpenMedicines(false)} />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "90%" }}
        open={openMedicinesSaltEnquiry}
        onClose={() => setOpenMedicinesSaltEnquiry(false)}
      >
        <MedicinesEnquiry onClose={() => setOpenMedicinesSaltEnquiry(false)} />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "90%" }}
        open={openMedicinesSalt}
        onClose={() => setOpenMedicinesSalt(false)}
      >
        <MedicineSalt onClose={() => setOpenMedicinesSalt(false)} />
      </CustomModal>

      <CustomModal
        customStyles={{
          border: "none",
          width: "90%",
          backgroundColor: "neutral.blueShadeBg",
        }}
        open={MedicalTest}
        onClose={() => setMedicalTest(false)}
      >
        <MedicalTests onClose={() => setMedicalTest(false)} />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "90%" }}
        open={openPharmacy}
        onClose={() => setOpenPharmacy(false)}
      >
        <PharmacyAdmin onClose={() => setOpenPharmacy(false)} />
      </CustomModal>
    </>
  );
};

export default PharmacyNavbar;
